import React from 'react';
import {Flex,
        Image,
        Drawer,
        DrawerBody,
        DrawerFooter,
        DrawerHeader,
        DrawerOverlay,
        DrawerContent,
        useDisclosure,
        Button,
        IconButton,
        Box,
    } from '@chakra-ui/react';
import { StyleSheet, css } from 'aphrodite';
import { FaBars } from "react-icons/fa6";
import { Link } from "react-router-dom"; // Import useLocation and Link

function MobileNavbarFr() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()
  return (
    <>
    <Box className={css(styles.container)}>
        <Flex >
            <Box height="5%">
                <Link to='/'>
                    <Image src="traversal_logo.png" alt="nserc logo" boxSize="40%" fit="contain" />
                </Link>
            </Box>
            <Flex width="100%" alignItems='center'>
                <IconButton ref={btnRef} onClick={onOpen} size='lg' variant='ghost' icon={<FaBars />} className={css(styles.icon)}/>
            </Flex>
        </Flex>
        <Flex className={css(styles.slidingTab)}>
            <Flex className={css(styles.content)}>
            LA FORMATION ET LA RECHERCHE SUR LES VÉHICULES AUTONOMES POUR DES SERVICES FIABLES DANS LES AIRS ET AU SOL (TRAVERSAL)
            &emsp; &emsp; &emsp; &emsp;
            LA FORMATION ET LA RECHERCHE SUR LES VÉHICULES AUTONOMES POUR DES SERVICES FIABLES DANS LES AIRS ET AU SOL (TRAVERSAL)
            &emsp; &emsp; &emsp; &emsp;
            LA FORMATION ET LA RECHERCHE SUR LES VÉHICULES AUTONOMES POUR DES SERVICES FIABLES DANS LES AIRS ET AU SOL (TRAVERSAL)
            </Flex>
        </Flex>
    </Box>

    <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
            <DrawerHeader>
                <Flex>
                    <Flex width="100%">
                        Explorer Le CRSNG
                    </Flex>
                    <Flex justifyContent="right" width="100%">
                        <Button variant='solid'>
                            <Link to='/'>
                                En/Fr
                            </Link>
                        </Button>
                    </Flex>
                </Flex>
            </DrawerHeader>
          
          <DrawerBody width="100%">
            <Flex className={css(styles.DrawerContent)}>
                <Flex className={css(styles.links)}>
                    <Link to='/fr'>
                        ACCUEIL
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/about-us-fr'>
                        L'EQUIPE
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/program-fr'>
                        PROGRAMME
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/seminars-fr'>
                        SÉMINAIRES
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/publications-fr'>
                        PUBLICATIONS
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/news-fr'>
                        NOUVELLES
                    </Link>
                </Flex>
                <hr />
                <Flex className={css(styles.links)}>
                    <Link to='/contact-us-fr'>
                        CONTACTEZ-NOUS
                    </Link>
                </Flex>
                <hr />
            </Flex>
          </DrawerBody>

          <DrawerFooter>
            <Button variant='outline' mr={3} onClick={onClose}>
                Fermer
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
};

const styles = StyleSheet.create({
    container: {
        width: '100vw',
        backgroundColor: ' #e2e1dc  ' ,
        position: 'fixed',
        top: 0,
        zIndex: 10
    },
    icon: {
        justifyContent: 'right',
        width: '100%',
        padding: 0,
        marginRight: '5%',
        marginTop: 5,
        ':hover': {
            backgroundColor: '#e2e1dc'
        }
    },
    DrawerContent: {
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
    },
    links: {
        fontWeight: 'bold',
        marginBottom: 5,
        justifyContent: 'center',
        width: '100%',
    },
    slidingTab: {
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      },
    content: {
        animationName: {
            '0%': {
                transform: 'translateX(100%)',
            },
            '100%': {
                transform: 'translateX(-100%)',
            },
        },
        animationDuration: '10s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        color: 'black', // Set text color to white or your preferred color
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        left: 0,
        width: '100%', // Ensure the content takes up the full width
    },
})

export default MobileNavbarFr